<template>
  <el-form :inline="true" :model="formApartment">
    <!-- 添加楼层 -->
    <el-dialog
      :title="$t('apartmentDetail.addFloor')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addFloorVisible"
      width="400px"
    >
      <el-form-item :label="$t('apartmentDetail.floorName')" label-width="120px">
        <el-input
         type="text"
         v-model="addFloorName"
         maxlength="12"
         show-word-limit
         :placeholder="$t('apartmentDetail.floorName')" style="width:200px"
        ></el-input>
      </el-form-item>
      <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="addFloor">{{$t('apartmentDetail.confirm')}}</el-button>
          <el-button type="primary" @click="addFloorVisible=false">{{$t('apartmentDetail.cancel')}}</el-button>
      </el-form-item>  
    </el-dialog>
    <!-- 添加分散式房间 -->
    <el-dialog
      :title="$t('apartmentDetail.addRoom')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addRoomFSSVisible"
      width="400px"
    >
      <el-form-item :label="$t('apartmentDetail.roomName')" label-width="120px">
        <el-input
          type="text"
          v-model="addRoomName"
          maxlength="8"
          show-word-limit
          :placeholder="$t('apartmentDetail.roomName')" 
          style="width:200px"
        ></el-input>
      </el-form-item>
      <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="addFSRoom">{{$t('apartmentDetail.confirm')}}</el-button>
          <el-button type="primary" @click="addRoomFSSVisible=false">{{$t('apartmentDetail.cancel')}}</el-button>
      </el-form-item>  
    </el-dialog>
    <!-- 添加集中式房间 -->
    <el-dialog
      :title="$t('apartmentDetail.addRoom')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addRoomJZSVisible"
      width="400px"
    >
      <el-form-item :label="$t('apartmentDetail.floor')" label-width="120px" prop="addFloorId">
        <el-select v-model="addFloorId" filterable clearable :placeholder="$t('apartmentDetail.floor')" style="width:200px">
          <el-option
            v-for="item in this.formApartment.floors"
            :key="item.floorId"
            :label="item.floorName"
            :value="item.floorId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('apartmentDetail.roomName')" label-width="120px">
        <el-input
          type="text"
          v-model="addRoomName"
          maxlength="8"
          show-word-limit
          :placeholder="$t('apartmentDetail.roomName')" 
          style="width:200px"
        ></el-input>
      </el-form-item>
      <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="addRoom">{{$t('apartmentDetail.confirm')}}</el-button>
          <el-button type="primary" @click="addRoomJZSVisible=false">{{$t('apartmentDetail.cancel')}}</el-button>
      </el-form-item>  
    </el-dialog>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{$t('apartmentDetail.apartmentInfo')}}</span>
        <el-button type="danger" size="mini" icon="el-icon-delete" style="float: right;" :title="$t('apartmentDetail.deleteApartment')" @click="delBtn"></el-button>
        <el-button type="primary" size="mini" :icon="formApartment.editBtnTex==1?'el-icon-edit':'el-icon-refresh'" style="float: right;" :title="formApartment.editBtnTex==1?$t('apartmentDetail.edit'):$t('apartmentDetail.cancel')" @click="editBtn"></el-button>
      </div>
      <el-form-item :label="$t('apartmentDetail.apartmentName')">
        <el-input
          v-model="formApartment.apartmentName"
          :disabled="formApartment.isDisabled"
          :placeholder="$t('apartmentDetail.apartmentName')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('apartmentDetail.area')">
        <el-input style="width:180px" v-show="language=='en'" :disabled="formApartment.isDisabled" v-model="formApartment.province" :placeholder="$t('addApartmentFSS.province')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="formApartment.province"
          :disabled="formApartment.isDisabled"
          @change="getProvinceValue"
         :placeholder="$t('apartmentDetail.province')"
        >
          <el-option
            v-for="item in this.$store.state.provinceList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-input style="width:180px" v-show="language=='en'" :disabled="formApartment.isDisabled" v-model="formApartment.city" :placeholder="$t('addApartmentFSS.city')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="formApartment.city"
          :disabled="formApartment.isDisabled"
          @change="getCityValue"
          :placeholder="$t('apartmentDetail.city')"
        >
          <el-option
            v-for="item in this.$store.state.cityList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-input style="width:180px" v-show="language=='en'" :disabled="formApartment.isDisabled" v-model="formApartment.area" :placeholder="$t('apartmentDetail.area-county')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="formApartment.area"
          :disabled="formApartment.isDisabled"
          :placeholder="$t('apartmentDetail.area-county')"
        >
          <el-option
            v-for="item in this.$store.state.areaList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('apartmentDetail.apartmentType')">
        <el-select
          v-model="formApartment.apartmentType"
          :disabled="formApartment.isDisabled"
          :placeholder="$t('apartmentDetail.apartmentType')"
         
          style="width:200px;"
        >
          <el-option key="0" :label="$t('apartmentDetail.fss')" value="0"></el-option>
          <el-option key="1" :label="$t('apartmentDetail.jzs')" value="1"></el-option>
          <el-option key="2" :label="$t('apartmentDetail.jds')" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('apartmentDetail.address')">
        <el-input
          v-model="formApartment.apartmentAddress"
          :disabled="formApartment.isDisabled"
          :placeholder="$t('apartmentDetail.apartmentAddress')"
          style="width:480px"
        ></el-input>
        <el-button type="primary" v-show="!formApartment.isDisabled" @click="saveApartment">{{$t('apartmentDetail.saveApartmentInfo')}}</el-button>
      </el-form-item>
    </el-card>

    <el-card class="box-card" style="margin-top:15px" v-show="formApartment.apartmentType=='0'">
      <div slot="header" style="height:40px;line-height: 40px;">
        <span>{{$t('apartmentDetail.roomInfo')}}</span>
        <el-button-group style="float: right; padding: 3px 0">
          <!-- <el-button type="primary" icon="el-icon-plus">新增楼栋</el-button> -->
          <el-button type="primary" icon="el-icon-plus" @click="addRoomFSSVisible=true">{{$t('apartmentDetail.addRoom')}}</el-button>
        </el-button-group>
      </div>
      <div v-for="o in formApartment.roomData" :key="o.roomId" class="text item">
        <el-col :span="6" style="height:60px">
            <el-input :placeholder="$t('apartmentDetail.roomName-input')" v-model="o.roomName" style="width:80%">
            <el-button slot="append" :title="$t('apartmentDetail.save')" @click="saveRoom(o)" style="color:blue;width:50px" icon="el-icon-folder-checked"></el-button>
            <el-button slot="append" :title="$t('apartmentDetail.delete')" @click="delRoom(o)" style="color:red;" icon="el-icon-delete"></el-button>
          </el-input>
        </el-col>
      </div>
    </el-card>
    <el-card
      class="box-card"
      style="margin-top:15px"
      v-show="formApartment.apartmentType=='1'||formApartment.apartmentType=='2'"
    >
      <div slot="header" style="height:40px;line-height: 40px;">
        <span>{{$t('apartmentDetail.roomInfo')}}</span>
        <!-- <el-select style="width:150px;margin-left:50px"
          v-model="formApartment.selectBuliding"
          @change="buildSelect"
          placeholder="请选择楼栋" 
          :clearable="true"
        >
          <el-option
            v-for="item in this.$store.state.buildingList"
            :key="item.buildingId"
            :label="item.buildingName"
            :value="item.buildingId"
          ></el-option>
        </el-select>-->
        <el-button-group style="float: right; padding: 3px 0">
          <!-- <el-button type="primary" icon="el-icon-plus">新增楼栋</el-button> -->
          <el-button type="primary" icon="el-icon-plus" @click="addFloorVisible=true">{{$t('apartmentDetail.addFloor')}}</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="addRoomJZSVisible=true">{{$t('apartmentDetail.addRoom')}}</el-button>
        </el-button-group>
      </div>
      <div v-show="formApartment.apartmentType=='1'||formApartment.apartmentType=='2'">
        <div v-for="b in formApartment.buildings" :key="b.buildingId" class="text item">
          <el-container>
            <!-- <el-header
              style="text-align: center;height:40px;line-height: 40px;border:solid 1px #888888;"
            >{{b.buildingName}}</el-header>-->
            <el-main style="text-align: center;">
              <div v-for="f in formApartment.floors" :key="f.floorId" class="text item">
                <el-container>
                  <el-aside style="overflow-x:hidden;margin-top:2px;width:100px;border:solid 1px #888888;display:flex;justify-content:center;align-items:center;">
                     <el-form>
                    <el-row style="width:90px">
                       <el-col :span="24" style="word-wrap:break-word;">{{f.floorName}}</el-col>
                    </el-row>
                    <el-row>
                       <el-col :span="24">
                        <el-button :title="$t('apartmentDetail.deleteFloor')" @click="delFloor(f)" size="mini" style="color:red;margin-left:3px" icon="el-icon-delete"></el-button>
                       </el-col>   
                     </el-row>
                     </el-form>
                  </el-aside>
                  <el-main>
                    <div v-for="r in f.roomList" :key="r.roomId" class="text item">
                      <el-col :span="8" style="height:60px">
                          <el-input :placeholder="$t('apartmentDetail.roomName')" v-model="r.roomName" style="width:80%">
                          <el-button slot="append" :title="$t('apartmentDetail.save')" @click="saveRoom(r)" style="color:blue;width:30px" icon="el-icon-folder-checked"></el-button>
                          <el-button slot="append" :title="$t('apartmentDetail.delete')" @click="delRoom(r)" style="color:red;" icon="el-icon-delete"></el-button>
                        </el-input>
                      </el-col>
                    </div>
                  </el-main>
                </el-container>
              </div>
            </el-main>
          </el-container>
        </div>
      </div>
    </el-card>
  </el-form>
</template> 
<script>
export default {
  name: "apartmentDetail",
  props: ["idata","tabIndex"],
  data() {
    return {
      language:localStorage.getItem("language"),
      addFloorId: null,
      addRoomName:"",
      addFloorName:"",
      addFloorVisible: false,
      addRoomFSSVisible: false,
      addRoomJZSVisible: false,
      formApartment: {
        apartmentName: this.idata.apartmentName,
        province: this.idata.province,
        city: this.idata.city,
        area: this.idata.area,
        apartmentType: this.idata.apartmentType + "",
        apartmentAddress: this.idata.apartmentAddress,
        roomData: this.roomList(), //分散型公寓的房间列表
        editBtnTex: 1, //编辑按钮文字显示
        isDisabled: true, //公寓信息是否编辑状态
        buildings: [],
        floors: [],
        selectBuliding: ""
      }
    };
  },
  created() {
    this.$store.commit("province", {}); //加载省份
    if(this.idata.provinceCode!=""&&this.idata.provinceCode!=null){
      var pobj={};
      pobj.provinceCode=this.idata.provinceCode;
      this.$store.commit("city",pobj); //加载市区
    }
    if(this.idata.cityCode!=""&&this.idata.cityCode!=null){
      var cobj={};
      cobj.cityCode=this.idata.cityCode;
      this.$store.commit("area", cobj); //加载区
    }
    this.$store.commit("buildings", {apartmentId: this.idata.apartmentId}); //加载楼栋列表
    this.$store.commit("roomType", {apartmentId: this.idata.apartmentId}); //加载楼栋列表
    this.getApartmentDetail();
  },
  methods: {
    saveApartment(val) {
        var formData = new FormData();
        formData.append("apartmentId",this.idata.apartmentId);
        formData.append("apartmentAddress",this.formApartment.apartmentAddress);
        formData.append("apartmentName",this.formApartment.apartmentName);
        if(this.language=='zh'){
          formData.append("provinceCode",this.formApartment.province);
          formData.append("cityCode",this.formApartment.city);
          formData.append("areaCode",this.formApartment.area);
        }else{
          formData.append("provinceName",this.formApartment.province);
          formData.append("cityName",this.formApartment.city);
          formData.append("areaName",this.formApartment.area); 
        }
      
        this.$server
        .exam("/customer/apartment/editApartment", formData)
        .then(data => {
          this.formApartment.editBtnTex=0, //编辑按钮文字显示
          this.formApartment.isDisabled=true, //公寓信息是否编辑状态
          this.addFloorVisible=false;
          if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
            });
            this.getApartmentDetail(); 
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    delBtn(val) {
        this.$confirm(this.$t("apartmentDetail.deleteApartment-confirm1")+ this.idata.apartmentName+this.$t("apartmentDetail.deleteApartment-confirm2"), this.$t("apartmentDetail.hint"), {
          confirmButtonText: this.$t("apartmentDetail.confirm"),
          cancelButtonText: this.$t("apartmentDetail.cancel"),
          type: 'warning'
        }).then(() => {
         var formData = new FormData();
         formData.append("apartmentId", this.idata.apartmentId);
         this.$server
          .exam("/customer/apartment/deleteApartment", formData)
          .then(data => {
           if (data.code == 200) {
            this.$main.removeTab(this.tabIndex);
            this.$message({
              message: data.message,
              type: "success"
            });
            var data = {};
            data.tabName = "公寓列表";
            data.id = "1";
            data.comp = "apartmentList";
            this.$main.addApartmentTab(data);
            this.$emit('tabIndex', 1);
           } else {
             this.$message({
              message: data.message,
              type: "warning"
             });
           }
        });
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t("apartmentDetail.alreadyDelete")
          });          
        });
       
    },
    delFloor(floorData){
       this.$confirm(this.$t("apartmentDetail.deleteFloor-confirm1")+floorData.floorName+this.$t("apartmentDetail.deleteFloor-confirm2"), this.$t("apartmentDetail.hint"), {
          confirmButtonText: this.$t("apartmentDetail.confirm"),
          cancelButtonText:  this.$t("apartmentDetail.cancel"),
          type: 'warning'
        }).then(() => {
         var formData = new FormData();
         formData.append("floorId ", floorData.floorId );
         this.$server
        .exam("/customer/apartment/deleteFloor ", formData)
        .then(data => {
          this.addFloorVisible=false;
          if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
             });
             if(this.idata.apartmentType==0){
               this.roomList(); 
             }else{
               this.getApartmentDetail(); 
             }
           } else {
             this.$message({
              message: data.message,
              type: "warning"
             });
           }
         });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t("apartmentDetail.alreadyDelete")
          });          
        });
    },
    saveRoom(roomData){
       var formData = new FormData();
       formData.append("roomId", roomData.roomId);
       formData.append("roomName", roomData.roomName);
       this.$server
        .exam("/customer/apartment/editApartmentRoom", formData)
        .then(data => {
          this.addFloorVisible=false;
          if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
            });
            if(this.idata.apartmentType==0){
               this.roomList(); 
            }else{
               this.getApartmentDetail(); 
            }
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    delRoom(roomData){
       this.$confirm(this.$t("apartmentDetail.deleteRoom-confirm1")+roomData.roomName+this.$t("apartmentDetail.deleteRoom-confirm2"), this.$t("apartmentDetail.hint"), {
          confirmButtonText: this.$t("apartmentDetail.confirm"),
          cancelButtonText:this.$t("apartmentDetail.cancel"),
          type: 'warning'
        }).then(() => {
          var formData = new FormData();
          formData.append("roomId", roomData.roomId);
          this.$server
          .exam("/customer/apartment/deleteRoom", formData)
          .then(data => {
            this.addFloorVisible=false;
            if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
            });
            if(this.idata.apartmentType==0){
               this.roomList(); 
            }else{
               this.getApartmentDetail(); 
            }
          } else {
             this.$message({
              message: data.message,
              type: "warning"
             });
          }
        });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t("apartmentDetail.alreadyDelete")
          });          
        });
    },

    addFloor(){
      if(this.addFloorName==""||this.addFloorName==null){
          this.$message({
            message: this.$t("apartmentDetail.floorName-input"),
            type: "warning"
          });
          return false;
      }
      var formData = new FormData();
      formData.append("apartmentId", this.idata.apartmentId);
      formData.append("buildingId",this.formApartment.buildings[0].buildingId);
      formData.append("floorName", this.addFloorName+"层");
      this.$server
        .exam("/customer/apartment/addApartmentFloor", formData)
        .then(data => {
          this.addFloorVisible=false;
          if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
            });
            this.getApartmentDetail(); 
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    //分散型公寓增加房间
    addFSRoom(){
      if(this.addRoomName==""||this.addRoomName==null){
          this.$message({
            message:this.$t("apartmentDetail.roomName-input"),
            type: "warning"
          });
          return false;
      }
      var formData = new FormData();
      formData.append("apartmentId", this.idata.apartmentId);
      
      // formData.append("floorId", this.$store.state. buildingList[0].floorList[0].floorId);
      formData.append("floorId", this.formApartment.buildings[0].floorList[0].floorId);
      formData.append("roomName", this.addRoomName+this.$t("apartmentDetail.room"));
      formData.append("roomTypeId", this.$store.state.roomTypeList[0].roomTypeId);
      this.$server
        .exam("/customer/apartment/addApartmentRoom", formData)
        .then(data => {
          this.addRoomFSSVisible=false;
          if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
            });
            this.roomList(); 
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    
     //集中型公寓增加房间
    addRoom(){
      if(this.addFloorId==""||this.addFloorId==null){
          this.$message({
            message: this.$t("apartmentDetail.floor-select"),
            type: "warning"
          });
          return false;
      }
      if(this.addRoomName==""||this.addRoomName==null){
          this.$message({
            message: this.$t("apartmentDetail.roomName"),
            type: "warning"
          });
          return false;
      }
      var formData = new FormData();
      formData.append("apartmentId", this.idata.apartmentId);
      formData.append("floorId", this.addFloorId);
      formData.append("roomName", this.addRoomName+this.$t("apartmentDetail.room"));
      formData.append("roomTypeId", this.$store.state.roomTypeList[0].roomTypeId);
      this.$server
        .exam("/customer/apartment/addApartmentRoom", formData)
        .then(data => {
          this.addRoomJZSVisible=false;
          if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
            });
            this.getApartmentDetail(); 
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
  
    editBtn(val) {
      if (this.formApartment.editBtnTex == 1) {
        this.formApartment.editBtnTex = 0;
        this.formApartment.isDisabled = false;
      } else {
        this.formApartment.editBtnTex = 1;
        this.formApartment.isDisabled = true;
      }
    },
    getCityValue(val) {
      this.$store.commit("area", { cityCode: val }); //加载区（县）
      this.formApartment.area = "";
    },
    getProvinceValue(val) {
      this.$store.commit("city", { provinceCode: val }); //加载城市
      this.formApartment.city = "";
      this.formApartment.area = "";
    },
    roomList() {
      var formData = new FormData();
      formData.append("apartmentId", this.idata.apartmentId);
      this.$server
        .exam("/customer/apartment/listRoom", formData)
        .then(data => {
          if (data.code == 200) {
            this.formApartment.roomData = data.data;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    getApartmentDetail() {
      var formData = new FormData();
      formData.append("apartmentId", this.idata.apartmentId);
      // if (this.formApartment.selectBuliding != "") {
      //   formData.append("buildingId", this.formApartment.selectBuliding);
      // }
      this.$server
        .exam("/customer/apartment/listApartmentBuilding", formData)
        .then(data => {
          if (data.code == 200) {
            var apmData = data.data;
            this.formApartment.buildings = apmData;
            for (var str in apmData) {
              var bldData = apmData[str];
              var floorData = bldData.floorList;
              this.formApartment.floors = bldData.floorList;
            }
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    }
  }
};
</script>  


// WEBPACK FOOTER //
// src/components/apartment/apartmentDetail.vue